<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Home",
      items: [
        {
          text: "Home",
          href: "/",
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    Traffic Citation Management System ver. 3.0
                </div>
                <div class="card-body">
                    <h1>Welcome to TCMS v3 Homepage</h1>
                </div>
            </div>
        </div>
    </div>
  </Layout>
</template>
